import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'removeBrackets',

})
export class RemoveBracketsPipe implements PipeTransform {

    transform(value: string | undefined): string {
        let regex: RegExp = /\(.*?\)/g;
        return value ? value.replace(regex, "") : '';
    }

}
